var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChatCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.143,
    height: 18,
    viewBox: "0 0 23.143 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-comments",
    "data-name": "Icon awesome-comments",
    d: "M16.714,8.679c0-3.552-3.741-6.429-8.357-6.429S0,5.127,0,8.679a5.451,5.451,0,0,0,1.527,3.7,9.043,9.043,0,0,1-1.438,2.19.319.319,0,0,0-.06.35.315.315,0,0,0,.293.193,7.074,7.074,0,0,0,3.564-1,10.223,10.223,0,0,0,4.472,1C12.974,15.107,16.714,12.23,16.714,8.679Zm4.9,8.839a5.443,5.443,0,0,0,1.527-3.7c0-2.688-2.15-4.99-5.2-5.95A5.971,5.971,0,0,1,18,8.679c0,4.255-4.327,7.714-9.643,7.714a12.046,12.046,0,0,1-1.274-.076c1.266,2.31,4.239,3.933,7.7,3.933a10.168,10.168,0,0,0,4.472-1,7.074,7.074,0,0,0,3.564,1,.317.317,0,0,0,.293-.193.322.322,0,0,0-.06-.35A8.947,8.947,0,0,1,21.616,17.518Z",
    transform: "translate(0 -2.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatCircle);
export default __webpack_public_path__ + "static/media/icon-chat-circle.9ab638dddfd64c97bc987cbf6109fdda.svg";
export { ForwardRef as ReactComponent };